class ThumbnailGenerator {
  constructor(video) {
    this.video = video instanceof File ? URL.createObjectURL(video) : video
  }

  asDataUrl() {
    return new Promise(async (resolve) => {
      const videoElement = await this._createVideoElement()
      const canvas = this._createCanvas(videoElement)
      const context = canvas.getContext('2d')

      videoElement.onloadeddata = () => {
        canvas.width = videoElement.videoWidth
        canvas.height = videoElement.videoHeight
        videoElement.currentTime = 0
      }
      videoElement.onseeked = () => {
        context.drawImage(videoElement, 0, 0)
        resolve(canvas.toDataURL())
      }
      videoElement.src = this.video
      videoElement.load()
    })
  }

  _createVideoElement() {
    return new Promise((resolve) => {
      const videoElement = document.createElement('video')
      videoElement.setAttribute('controls', true)
      videoElement.setAttribute('playsinline', true)
      videoElement.setAttribute('webkit-playsinline', true)
      videoElement.setAttribute('x5-playsinline', true)
      videoElement.setAttribute('x5-video-player-type', 'h5')
      videoElement.setAttribute('x5-video-player-fullscreen', false)
      resolve(videoElement)
    })
  }

  _createCanvas(videoElement) {
    const canvas = document.createElement('canvas')
    canvas.height = videoElement.videoHeight
    canvas.width = videoElement.videoWidth
    return canvas
  }
}

export default ThumbnailGenerator
